import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    Inject,
} from '@angular/core';
import { NgbActiveModal } from '@cmps/ng-bootstrap';
import { Subscription } from 'rxjs';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { IFrameService } from '../common/iframe.directive';

import { WebFormBase } from './webform.component';
import { TranslationKeyMap } from './webform.i18n';

@Component({
    selector: 'cmps-webform-modal',
    template: ` <div class="modal-header">
            <div
                class="modal-title h4"
                role="heading"
                aria-level="1"
            >
                {{ config.header }}
            </div>
            <button
                type="button"
                class="close"
                [attr.aria-label]="i18n._763_CLOSE | translate"
                (click)="activeModal.dismiss('dismiss')"
            >
                <cmps-icon svgIcon="close"></cmps-icon>
            </button>
        </div>
        <div
            class="modal-body"
            [style.height]="!hasScrolling ? 'auto' : '525px'"
        >
            <cmps-wait-status
                [absolute]="true"
                *ngIf="!ready"
            ></cmps-wait-status>
            <iframe
                class="cmps-iframe"
                cmps-iframe
                [newSrc]="this.config.currentUrl"
                [hasComm]="true"
                [scrolling]="hasScrolling ? 'yes' : 'no'"
                (onload)="ready = true"
                (unload)="ready = false"
                #iframe="cmpsIframe"
            ></iframe>
        </div>`,
})
export class ModalWebFormComponent
    extends WebFormBase
    implements AfterViewInit
{
    i18n = TranslationKeyMap;
    config: any;
    hasScrolling: boolean; // TODO remove. only used for scorecards
    protected _autoHeightSub: Subscription;

    constructor(
        private readonly _changeDetectionRef: ChangeDetectorRef,
        public activeModal: NgbActiveModal,
        @Inject(CMPS_APP_CONFIG) protected _appConfig: AppConfig,
        protected _iFrameService: IFrameService,
    ) {
        super(_appConfig, _iFrameService);
        this.hasScrolling = true;
    }

    ngAfterViewInit(): void {
        super.ngAfterViewInit();
        this._changeDetectionRef.detectChanges();
    }

    ngOnDestroy(): void {
        if (this._autoHeightSub) {
            this._autoHeightSub.unsubscribe();
        }
        super.ngOnDestroy();
    }

    protected _onDomContentLoaded(message: any): void {
        super._onDomContentLoaded(message);
        if (this.hasScrolling) return;
        this._iFrameService.postMessage(this.iframe, {
            method: 'getClientHeight',
            selector: 'div[id*="Viewer"]',
        });
    }

    protected _responseToGetClientHeight(message: any): void {
        if (this.hasScrolling) return;
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/restrict-plus-operands
        this.iframe.el.nativeElement.style.height = `${
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/restrict-plus-operands
            message.clientHeight + 20
        }px`;
    }
}
